import { FC, SVGProps } from 'react';
import { creditCards } from '@/assets/icons/credit-cards/creditCards';
import { ReactComponent as Banknot } from '../../assets/icons/banknot.svg';
import { ReactComponent as Success } from '../../assets/icons/success.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ReactComponent as Lock } from '../../assets/icons/lock.svg';
import { ReactComponent as User } from '../../assets/icons/user.svg';
import { ReactComponent as Search } from '../../assets/icons/search.svg';
import { ReactComponent as Shield } from '../../assets/icons/shield.svg';
import { ReactComponent as Wallet } from '../../assets/icons/wallet.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrowRight.svg';
import { ReactComponent as Logout } from '../../assets/icons/logout.svg';
import { ReactComponent as ArrowLeftOutlined } from '../../assets/icons/arrowLeftOutlined.svg';
import { ReactComponent as ArrowRightOutlined } from '../../assets/icons/arrowRightOutlined.svg';
import { ReactComponent as ChevronDown } from '../../assets/icons/chevronDown.svg';
import { ReactComponent as ChevronRight } from '../../assets/icons/chevronRight.svg';
import { ReactComponent as LightBulb } from '../../assets/icons/lightBulb.svg';
import { ReactComponent as Admin } from '../../assets/icons/logo-admin.svg';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';
import { ReactComponent as Franchise } from '../../assets/icons/franchisee.svg';
import { ReactComponent as Consultant } from '../../assets/icons/users.svg';
import { ReactComponent as Promotion } from '../../assets/icons/promotion.svg';
import { ReactComponent as Popup } from '../../assets/icons/popup.svg';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as Payments } from '../../assets/icons/payments.svg';
import { ReactComponent as Profile } from '../../assets/icons/profile.svg';
import { ReactComponent as LogOut } from '../../assets/icons/log-out.svg';
import { ReactComponent as BurgerMenu } from '../../assets/icons/burgerMenu.svg';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as Dashboard } from '../../assets/icons/dashboard.svg';
import { ReactComponent as PremiumDashboard } from '../../assets/icons/premiumDashboard.svg';
import { ReactComponent as CreditCard } from '../../assets/icons/creditCard.svg';
import { ReactComponent as Bullet } from '../../assets/icons/bullet.svg';
import { ReactComponent as Mail } from '../../assets/icons/Mail.svg';
import { ReactComponent as Instagram } from '../../assets/icons/isntagram.svg';
import { ReactComponent as LinkedIn } from '../../assets/icons/linkedin.svg';
import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as ThreeDots } from '../../assets/icons/3Dots.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrowLeft.svg';
import { ReactComponent as UserCircle } from '../../assets/icons/userCircle.svg';
import { ReactComponent as UserLogout } from '../../assets/icons/userLogout.svg';
import { ReactComponent as Chat } from '../../assets/icons/chat.svg';
import { ReactComponent as Send } from '../../assets/icons/send.svg';
import { ReactComponent as Attachment } from '../../assets/icons/attachment.svg';
import { ReactComponent as Bell } from '../../assets/icons/bell.svg';
import { ReactComponent as Help } from '../../assets/icons/help.svg';
import { ReactComponent as Heart } from '../../assets/icons/heart.svg';
import { ReactComponent as Building } from '../../assets/icons/building.svg';
import { ReactComponent as Map } from '../../assets/icons/map.svg';
import { ReactComponent as Globe } from '../../assets/icons/globe.svg';
import { ReactComponent as Messages } from '../../assets/icons/messages.svg';
import { ReactComponent as BookOpen } from '../../assets/icons/bookOpen.svg';
import { ReactComponent as Landscape } from '../../assets/icons/landscape.svg';
import { ReactComponent as LogoutDark } from '../../assets/icons/logout-dark.svg';
import { ReactComponent as Settings } from '../../assets/icons/settings.svg';
import { ReactComponent as Contact } from '../../assets/icons/contact.svg';
import { ReactComponent as Financial } from '../../assets/icons/financial.svg';
import { ReactComponent as Training } from '../../assets/icons/training.svg';
import { ReactComponent as Garbage } from '../../assets/icons/garbage.svg';
import { ReactComponent as Mountains } from '../../assets/icons/mountains.svg';
import { ReactComponent as CheckCircleFilled } from '../../assets/icons/checkCircleFilled.svg';
import { ReactComponent as Brand } from '../../assets/icons/brand.svg';
import { ReactComponent as Stars } from '../../assets/icons/stars.svg';
import { ReactComponent as Referral } from '../../assets/icons/referral.svg';
import { ReactComponent as Checkbox } from '../../assets/icons/checkbox.svg';
import { ReactComponent as Document } from '../../assets/icons/document.svg';
import { ReactComponent as Book } from '../../assets/icons/book.svg';
import { ReactComponent as GreenWarning } from '../../assets/icons/warning-green.svg';
import { ReactComponent as Check } from '../../assets/icons/check.svg';
import { ReactComponent as LockUnlock } from '../../assets/icons/lock-unlocked.svg';
import { ReactComponent as Tag } from '../../assets/icons/tag.svg';
import { ReactComponent as StarFall } from '../../assets/icons/star-fall.svg';
import { ReactComponent as FDDFiles } from '../../assets/icons/fdd-files.svg';
import { ReactComponent as Google } from '../../assets/icons/google.svg';
import { ReactComponent as Office365 } from '../../assets/icons/365.svg';
import { ReactComponent as SearchIconInput } from '../../assets/icons/searchInput.svg';
import { ReactComponent as ArrowUpLeft } from '../../assets/icons/arrowUpLeft.svg';
import { ReactComponent as AiIcon } from '../../assets/icons/aiIcon.svg';
import { ReactComponent as StarAiIcon } from '../../assets/icons/startAiIcon.svg';
import { ReactComponent as GoldStar } from '../../assets/icons/gold_star.svg';
import { ReactComponent as FileShield } from '../../assets/icons/fileShield.svg';
import { ReactComponent as Star } from '../../assets/icons/star.svg';
import { ReactComponent as Link } from '../../assets/icons/link.svg';
import { ReactComponent as FoldMap } from '../../assets/icons/fold-map.svg';
import { ReactComponent as ZicZag } from '../../assets/icons/zic-zag.svg';
import { ReactComponent as GrayStar } from '../../assets/icons/gray-star.svg';
import { ReactComponent as Comments } from '../../assets/icons/comments.svg';
import { ReactComponent as BrandMapping } from '../../assets/icons/brandMapping.svg';
import { ReactComponent as DeleteRed } from '../../assets/icons/delete-red.svg';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';
import { ReactComponent as SettingsNew } from '../../assets/icons/settings-new.svg';
import { ReactComponent as BuildingNew } from '../../assets/icons/building-new.svg';
import { ReactComponent as LucideBot } from '../../assets/icons/lucide-bot.svg';
import { ReactComponent as VerifiedIcf } from '../../assets/icons/verified-icf.svg';
import { ReactComponent as FileText } from '../../assets/icons/file-text.svg';
import { ReactComponent as SquarePen } from '../../assets/icons/square-pen.svg';
import { ReactComponent as Upload } from '../../assets/icons/upload.svg';
import { ReactComponent as Attention } from '../../assets/icons/attention.svg';

export const icons = {
  banknot: Banknot,
  success: Success,
  plus: Plus,
  lock: Lock,
  user: User,
  search: Search,
  wallet: Wallet,
  shield: Shield,
  arrowRight: ArrowRight,
  logout: Logout,
  logoutDark: LogoutDark,
  arrowLeftOutlined: ArrowLeftOutlined,
  arrowRightOutlined: ArrowRightOutlined,
  chevronDown: ChevronDown,
  chevronRight: ChevronRight,
  lightBulb: LightBulb,
  burgerMenu: BurgerMenu,
  filter: Filter,
  creditCard: CreditCard,
  logoAdmin: Admin,
  alert: Alert,
  dashboard: Dashboard,
  premiumDashboard: PremiumDashboard,
  franchise: Franchise,
  consultant: Consultant,
  promotion: Promotion,
  popup: Popup,
  calendar: Calendar,
  payments: Payments,
  profile: Profile,
  logOut: LogOut,
  bullet: Bullet,
  instagram: Instagram,
  linkedin: LinkedIn,
  mail: Mail,
  facebook: Facebook,
  threeDots: ThreeDots,
  arrowLeft: ArrowLeft,
  userCircle: UserCircle,
  userLogout: UserLogout,
  chat: Chat,
  send: Send,
  attachment: Attachment,
  bell: Bell,
  help: Help,
  heart: Heart,
  building: Building,
  map: Map,
  globe: Globe,
  messages: Messages,
  bookOpen: BookOpen,
  landscape: Landscape,
  settings: Settings,
  contact: Contact,
  financial: Financial,
  training: Training,
  garbage: Garbage,
  mountains: Mountains,
  checkCircleFilled: CheckCircleFilled,
  brand: Brand,
  stars: Stars,
  referral: Referral,
  checkbox: Checkbox,
  document: Document,
  book: Book,
  warningGreen: GreenWarning,
  check: Check,
  lockUnlocked: LockUnlock,
  tag: Tag,
  starFall: StarFall,
  fddFiles: FDDFiles,
  google: Google,
  office365: Office365,
  searchInput: SearchIconInput,
  arrowUpLeft: ArrowUpLeft,
  ai: AiIcon,
  starAi: StarAiIcon,
  goldStar: GoldStar,
  fileShield: FileShield,
  star: Star,
  link: Link,
  foldMap: FoldMap,
  zigzag: ZicZag,
  grayStar: GrayStar,
  comments: Comments,
  brandMapping: BrandMapping,
  deleteRed: DeleteRed,
  edit: Edit,
  settingsNew: SettingsNew,
  buildingNew: BuildingNew,
  lucideBot: LucideBot,
  verifiedIcf: VerifiedIcf,
  fileText: FileText,
  squarePen: SquarePen,
  upload: Upload,
  attention: Attention,
  ...creditCards,
} as const;

export type IconsType = keyof typeof icons;

type SvgIconProps = SVGProps<SVGSVGElement> & { type: IconsType };

export const SvgIcon: FC<SvgIconProps> = ({ type, ...svgProps }) => {
  const IconComponent = icons[type];
  return IconComponent ? <IconComponent {...svgProps} /> : null;
};
